"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const ConfirmIdentity_vue_1 = tslib_1.__importDefault(require("./ConfirmIdentity.vue"));
exports.default = vue_1.default.extend({
    name: 'forgot-password-confirm-identity',
    components: {
        ConfirmIdentity: ConfirmIdentity_vue_1.default,
    },
});
